<template>
  <div>
    <PageSpinner :onloader="onloader" />
    <base-header type="gradient-success" class="pb-6 pb-8 pt-5 pt-md-8">
      <router-link to="/dashboard" class="text-white">
        Dashboard
      </router-link>
      <router-link to="/school/student-information-system" class="text-white">
        <i class="fa fa-ellipsis-v px-2"></i>Student Information System
      </router-link>
      <span class="text-white"><i class="fa fa-ellipsis-v px-2"></i>Student Profile
      </span>
    </base-header>

    <!--Charts-->
    <div class="container-fluid mt--7">
      <card header-classes="bg-transparent">
        <modal :show.sync="modals.studentModal" modal-classes="modal-dialog-centered">
          <div class="card border-0 mb-0">
            <div class="card-body">
              <PageSpinner :onloader="onloader" />
              <div class="form-horizontal">
                <form role="form">
                  <div class="card">
                    <h5 class="card-header">Biodata</h5>
                    <div class="card-body">
                      <div class="row">
                        <div class="col-md-12 pb-2">
                          <div class="row">
                            <div class="col-sm-12 col-md-6">
                              <img v-if="ImgPathval" :src="ImgPathval" class="img-fluid" />
                              <img v-else src="/img/brand/empty.png" class="img-fluid" />
                            </div>
                            <div class="col-sm-12 col-md-6">
                              <ImageUploader :existingPath="ImgPathval || ''" @emitOutImgPathval="updatePassportVal" />
                            </div>
                          </div>
                        </div>
                        <div class="col-sm-4">
                          <div class="form-group">
                            <label>Surname</label>
                            <input v-model="LastNameval" class="form-control" />
                          </div>
                        </div>
                        <div class="col-sm-4">
                          <div class="form-group">
                            <label>First Name</label>
                            <input v-model="FirstNameval" class="form-control" />
                          </div>
                        </div>
                        <div class="col-sm-4">
                          <div class="form-group">
                            <label>Other Name</label>
                            <input v-model="MiddleNameval" class="form-control" />
                          </div>
                        </div>
                        <div class="col-sm-4">
                          <div class="form-group">
                            <label>Sex</label>
                            <select v-model="SexIdval" class="form-control">
                              <option value="0"></option>
                              <option value="10">Male</option>
                              <option value="11">Female</option>
                            </select>
                          </div>
                        </div>
                        <div class="col-sm-4">
                          <div class="form-group">
                            <label>Date of Birth</label>
                            <input type="date" v-model="DOBval" :max="getTodayDate" class="form-control" />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <hr />
                  <div class="card">
                    <h5 class="card-header">Guardian</h5>
                    <div class="card-body">
                      <div class="row">
                        <div class="col-sm-4">
                          <div class="form-group">
                            <label>Guardian Surname</label>
                            <input v-model="GLastNameval" class="form-control" />
                          </div>
                        </div>
                        <div class="col-sm-4">
                          <div class="form-group">
                            <label>Guardian First Name</label>
                            <input v-model="GFirstnameval" class="form-control" />
                          </div>
                        </div>
                        <div class="col-sm-4">
                          <div class="form-group">
                            <label>Guardian Other Name</label>
                            <input v-model="GMiddlenameval" class="form-control" />
                          </div>
                        </div>
                        <div class="col-sm-4">
                          <div class="form-group">
                            <label>Guardian Phone Number</label>
                            <input v-model="GPhoneNoval" class="form-control" required />
                          </div>
                        </div>
                        <div class="col-sm-4">
                          <div class="form-group">
                            <label>Guardian Email Address</label>
                            <input v-model="GEmailval" class="form-control" />
                          </div>
                        </div>
                        <div class="col-md-12">
                          <div class="form-group">
                            <label>Full Address</label>
                            <textarea v-model="FullAddressval" class="form-control" rows="3" required></textarea>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <hr />
                  <div class="card">
                    <h5 class="card-header">Admission</h5>
                    <div class="card-body">
                      <div class="row">
                        <div class="col-sm-4">
                          <div class="form-group">
                            <label>Admission Number</label>
                            <input v-model="AdmissionNoval" class="form-control" />
                          </div>
                        </div>
                        <div class="col-sm-4">
                          <div class="form-group">
                            <label>Admission Date</label>
                            <input type="date" v-model="Admissiondateval" class="form-control" />
                          </div>
                        </div>
                        <div class="col-sm-4">
                          <div class="form-group">
                            <label>Class</label>
                            <select v-model="ClassIdval" @change="getoption()" class="form-control">
                              <option value="0"></option>
                              <option v-for="item in schclass" :key="item.Id" v-bind:value="item.Id">
                                {{ item.Sch_Class }}
                              </option>
                            </select>
                          </div>
                        </div>
                        <div class="col-sm-4">
                          <div class="form-group">
                            <label>Option</label>
                            <select v-model="OptionIdval" @change="getarm()" class="form-control">
                              <option value="0"></option>
                              <option v-for="item in optionitems" :key="item.Id" v-bind:value="item.Id">
                                {{ item.ClassOption }}
                              </option>
                            </select>
                          </div>
                        </div>
                        <div class="col-sm-4">
                          <div class="form-group">
                            <label>Arm</label>
                            <select v-model="ArmIdval" class="form-control">
                              <option value="0"></option>
                              <option v-for="item in armitems" :key="item.Id" v-bind:value="item.Id">
                                {{ item.SectionName }}
                              </option>
                            </select>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
          <div class="card-footer text-right">
            <base-button type="default" @click="modals.studentModal = false">Cancel
            </base-button>
            <base-button type="success" @click.prevent="submitdata()">Submit
            </base-button>
          </div>
        </modal>
        <modal :show.sync="modals.studentArchievementModal" modal-classes="modal-dialog-centered">
          <div class="card border-0 mb-0">
            <div class="card-body">
              <PageSpinner :onloader="onloader" />
              <div class="form-horizontal">

                <StudentAchievement :student-id="StudentIdVal" :student-details="studentitems" />
              </div>
            </div>
          </div>
          <div class="card-footer text-right">
            <base-button type="default" @click="modals.studentArchievementModal = false">Cancel
            </base-button>
          </div>
        </modal>
        <modal :show.sync="modals.studentNoteModal" modal-classes="modal-dialog-centered">
          <div class="card border-0 mb-0">
            <div class="card-body">
              <PageSpinner :onloader="onloader" />
              <div class="form-horizontal">

                <StudentNote :student-id="StudentIdVal" :student-details="studentitems" />
              </div>
            </div>
          </div>
          <div class="card-footer text-right">
            <base-button type="default" @click="modals.studentNoteModal = false">Cancel
            </base-button>
          </div>
        </modal>
        <modal :show.sync="modals.unifiedUploadModal" modal-classes="modal-dialog-centered modal-xl" modal-content-classes="bulk-upload-modal-content">
          <div class="card border-0 mb-0">
            <div class="card-header bg-transparent border-bottom d-flex justify-content-between align-items-center py-3">
              <h3 class="mb-0 text-primary">
                <i class="fa fa-user-graduate mr-2"></i>Student Details Upload
              </h3>
              <button type="button" class="close" @click="modals.unifiedUploadModal = false">
                <span>&times;</span>
              </button>
            </div>
            <div class="card-body p-3">
              <UnifiedStudentUpload
                :student-repository="studentRepoInstance"
                :schclass="schclass || []"
                :existing-students="students || []"
                :initial-class-id="ClassIdval"
                :initial-option-id="OptionIdval"
                :initial-arm-id="ArmIdval"
                :initial-mode="unifiedUploadInitialMode"
                @student-created="handleBulkStudentCreated"
                @close="modals.unifiedUploadModal = false"
              />
            </div>
          </div>
        </modal>
        <div>
          <ul class="nav nav-tabs mt-3" role="tablist">
            <li class="nav-item">
              <a class="nav-link" :class="{ active: activeTab === 'active' }" href="#"
                @click.prevent="activeTab = 'active'">
                Active Students <span class="badge badge-success">{{ activeStudents.length }}</span>
              </a>
            </li>
            <li class="nav-item">
              <a class="nav-link" :class="{ active: activeTab === 'deleted' }" href="#"
                @click.prevent="activeTab = 'deleted'">
                Deleted Students <span class="badge badge-danger">{{ deletedStudents.length }}</span>
              </a>
            </li>
          </ul>
          <div class="justify-content-end form-inline my-3">
            <button
              type="button"
              @click="downloadStudentList"
              class="btn btn-outline-primary mr-2"
              :disabled="!searchedResultQuery.length"
            >
              <i class="fa fa-download mr-1"></i>Download student list
            </button>
            <button type="button" @click.prevent="openUnifiedUpload('excel')" class="btn btn-outline-success mr-2">
              <i class="fa fa-file-excel mr-1"></i>Excel Bulk Upload
            </button>
            <button type="button" @click.prevent="openUnifiedUpload('manual')" class="btn btn-primary mr-2">
              <i class="fa fa-user-plus mr-1"></i>Add Student (Manual)
            </button>
            <base-input class="input-group-alternative" placeholder="Search here..." addon-left-icon="fa fa-search"
              v-model="searchval">
            </base-input>
          </div>
          <div class="row">
            <div class="col-lg-4" v-for="item in searchedResultQuery" :key="item.studentId">
              <div class="card text-center m-2 animate__animated animate__backInUp">
                <div class="card-body" :class="activeTab === 'deleted' ? 'bg-danger' : 'bg-success'">
                  <div class="row">
                    <div class="col-md-6">
                      <img v-if="item.passport" :src="item.passport" class="rounded" alt="" height="50" />
                      <img v-else src="/img/brand/loguser.png" class="rounded" alt="" height="50" />
                      <h5 class="text-white"><small>{{ item.studentName }}</small> </h5>
                      <h6 class="text-white"> <small>{{ item.admNo }} | {{ item.sch_Class }} | {{ item.classOption }} |
                          {{
                            item.sectionName
                          }}</small> </h6>
                      <small v-if="item.syncStatus && item.syncStatus !== 'synced'" class="text-white">
                        {{ item.syncStatus === 'failed' ? 'Sync failed' : item.syncStatus === 'syncing' ? 'Syncing' : 'Pending sync' }}
                      </small>
                      <div>
                        <button class="btn btn-secondary btn-sm my-2" v-on:click="edititem(item)">
                          <i class="fa fa-edit"></i>
                        </button>
                        <button v-if="item.isDeleted" class="btn btn-default btn-sm"
                          v-on:click="deletestudent(item.studentId)">
                          <i class="fa fa-history"></i>
                        </button>
                        <button v-else class="btn btn-danger btn-sm my-2" v-on:click="deletestudent(item.studentId)">
                          <i class="fa fa-times"></i>
                        </button>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <button class="btn btn-secondary btn-sm my-3"
                        v-on:click="addAchievement(item.studentId)">Achievement</button>
                      <br>
                      <button class="btn btn-secondary btn-sm" v-on:click="addNote(item.studentId)">Note</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-12" v-if="searchedResultQuery.length === 0">
              <p class="text-center text-muted my-4">No {{ activeTab === 'deleted' ? 'deleted' : 'active' }} students
                found</p>
            </div>
          </div>
        </div>
      </card>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import * as XLSX from "xlsx";
import Alert from "@/mixins/Alert.mixins"
import PageSpinner from "@/components/PageSpinner"
import CheckStaffUser from "@/mixins/CheckStaffUser.mixin"
import ImageUploader from "@/components/ImageUploader"
import StudentAchievement from '@/views/PortalSchool/StudentInformationSystem/Pages/Component/StudentAchievement.vue';
import StudentNote from '@/views/PortalSchool/StudentInformationSystem/Pages/Component/StudentNote.vue';
import UnifiedStudentUpload from '@/views/PortalSchool/StudentInformationSystem/Pages/Component/UnifiedStudentUpload.vue';
import { createOfflineRepository } from '@/rxdb/repository';
import { subscribeSynced } from '@/rxdb/offlineSync';
import { getCurrentUserScope } from '@/rxdb/sessionScope';

const studentRepository = createOfflineRepository({
  entityType: 'student',
  url: (data, operation) => operation === 'delete'
    ? `/Student/Deletestudent?Id=${data.studentId || data.Id}&Username=${data.Username}&Accesskey=${data.Accesskey}`
    : '/Student/ProcessStudent',
  method: (data, operation) => operation === 'delete' ? 'GET' : 'POST',
  dedupeKey: data => {
    const admNo = data && (data.admNo || data.AdmissionNo);
    return admNo ? String(admNo).trim().toLowerCase() : null;
  }
});

function displayStudent(student) {
  const source = student.data || student;
  const firstName = source.firstName || source.FirstName || '';
  const middleName = source.middleName || source.MiddleName || '';
  const lastName = source.lastName || source.LastName || '';
  return {
    ...source,
    studentId: source.studentId || source.Id || source.clientId,
    studentName: source.studentName || [firstName, middleName, lastName]
      .filter(Boolean).join(' '),
    passport: source.passport || source.Passport || '',
    admNo: source.admNo || source.AdmissionNo || '',
    sch_Class: source.sch_Class || source.Sch_Class || source.className || '',
    classOption: source.classOption || source.ClassOption || source.optionName || '',
    sectionName: source.sectionName || source.SectionName || source.armName || '',
    syncStatus: student.syncStatus || 'synced'
  };
}
export default {
  name: "StudentProfile",
  components: {
    PageSpinner, ImageUploader, StudentAchievement, StudentNote, UnifiedStudentUpload
  },
  mixins: [CheckStaffUser, Alert],
  data() {
    return {
      accessDetails: null,
      StudentIdVal: 0,
      ImgPathval: "",
      ContactIdval: 1,
      FirstNameval: "",
      MiddleNameval: "",
      LastNameval: null,
      SexIdval: "0",
      DOBval: "",
      UserIdval: 0,
      GIdval: 0,
      GContactIdval: 0,
      GUserIdval: 0,
      GPhoneNoval: "",
      GTitleval: "",
      GFirstnameval: "",
      GMiddlenameval: "",
      GLastNameval: "",
      GEmailval: "",
      FullAddressval: "",
      AddressIdval: 1,
      Addressval: "",
      AdmissionNoval: "",
      Admissiondateval: null,
      ClassIdval: 0,
      OptionIdval: 0,
      ArmIdval: 0,
      optionitems: [],
      armitems: [],
      students: null,
      schclass: null,
      file: "",
      uploadedimage: "",
      studentitems: null,
      searchval: "",
      activeTab: "active",
      process: "N",
      inputdisable: false,
      onloader: "none",
      modals: {
        studentModal: false,
        studentArchievementModal: false,
        studentNoteModal: false,
        bulkUploadModal: false,
        unifiedUploadModal: false
      },
      unifiedUploadInitialMode: "manual"
    };
  },
  computed: {
    getTodayDate() {
      const today = new Date();
      const year = today.getFullYear();
      const month = String(today.getMonth() + 1).padStart(2, '0');
      const day = String(today.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    },
    studentRepoInstance() {
      return studentRepository;
    },
    activeStudents() {
      if (!this.students) return [];
      return this.students.filter((item) => !item.isDeleted);
    },
    deletedStudents() {
      if (!this.students) return [];
      return this.students.filter((item) => item.isDeleted);
    },
    searchedResultQuery() {
      const tabList = this.activeTab === 'deleted' ? this.deletedStudents : this.activeStudents;
      if (this.searchval) {
        return tabList.filter((item) => {
          return this.searchval
            .toLowerCase()
            .split(" ")
            .every(
              (v) =>
                (item.studentName || "").toLowerCase().includes(v) ||
                (item.sch_Class || "").toLowerCase().includes(v) ||
                (item.admNo || "").toLowerCase().includes(v)
            );
        });
      } else {
        return tabList;
      }
    },
  },
  methods: {
    downloadStudentList() {
      const rows = this.searchedResultQuery.map((student) => ({
        "Student ID": student.studentId || student.Id || "",
        "Admission Number": student.admNo || student.AdmissionNo || "",
        Surname: student.lastName || student.LastName || student.surname || student.Surname || "",
        "First Name": student.firstName || student.FirstName || "",
        "Middle Name": student.middleName || student.MiddleName || "",
        Gender: student.gender || student.Gender || student.sex || student.Sex || student.sexId || student.SexId || "",
        "Date of Birth": student.dateOfBirth || student.DateOfBirth || student.DOB || "",
        Class: student.sch_Class || student.Sch_Class || student.className || student.ClassName || "",
        Option: student.classOption || student.ClassOption || student.optionName || "",
        Arm: student.sectionName || student.SectionName || student.armName || "",
        "Admission Date": student.dateAdmited || student.DateAdmited || student.admissionDate || "",
        Address: student.fullAddress || student.FullAddress || student.addressOne || student.AddressOne || "",
        "Guardian Name": [
          student.gFirstName || student.GFirstname || student.GFirstName,
          student.gMiddlename || student.GMiddlename || student.GMiddleName,
          student.gLastName || student.GLastName,
        ].filter(Boolean).join(" "),
        "Guardian Phone": student.gPhoneNo || student.GPhoneNo || "",
        "Guardian Email": student.gEmailAdd || student.GEmail || student.GEmailAdd || "",
        Status: student.isDeleted ? "Deleted" : "Active",
        "Sync Status": student.syncStatus || "synced",
      }));
      const worksheet = XLSX.utils.json_to_sheet(rows);
      worksheet["!cols"] = [
        { wch: 16 }, { wch: 20 }, { wch: 20 }, { wch: 20 }, { wch: 20 },
        { wch: 14 }, { wch: 16 }, { wch: 20 }, { wch: 20 }, { wch: 16 },
        { wch: 18 }, { wch: 36 }, { wch: 28 }, { wch: 18 }, { wch: 28 },
        { wch: 12 }, { wch: 16 },
      ];
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Students");
      XLSX.writeFile(
        workbook,
        `${this.activeTab}-students-${new Date().toISOString().slice(0, 10)}.xlsx`
      );
    },
    openUnifiedUpload(initialMode = 'manual') {
      this.unifiedUploadInitialMode = initialMode;
      this.modals.unifiedUploadModal = true;
    },
    OpenNewForm() {
      this.ImgPathval = "";
      this.GPhoneNoval = "";
      this.GTitleval = "";
      this.GFirstnameval = "";
      this.GMiddlenameval = "";
      this.GLastNameval = "";
      this.GEmailval = "";
      this.FirstNameval = "";
      this.FullAddressval = "";
      this.AdmissionNoval = "";
      this.Admissiondateval = null;
      this.ClassIdval = 0;
      this.OptionIdval = 0;
      this.ArmIdval = 0;
      this.MiddleNameval = "";
      this.LastNameval = "";
      this.SexIdval = "0";
      this.DOBval = "";
      this.file = "";
      this.uploadedimage = "";
      this.getadmno();
      this.modals.studentModal = true;
      this.process = "N";
      this.inputdisable = false;
    },
    CloseForm() {
      this.ImgPathval = "";
      this.GPhoneNoval = "";
      this.GTitleval = "";
      this.GFirstnameval = "";
      this.GMiddlenameval = "";
      this.GLastNameval = "";
      this.GEmailval = "";
      this.FirstNameval = "";
      this.Addressval = "";
      this.AdmissionNoval = "";
      this.Admissiondateval = null;
      this.ClassIdval = 0;
      this.OptionIdval = 0;
      this.ArmIdval = 0;
      this.MiddleNameval = "";
      this.LastNameval = "";
      this.SexIdval = 0;
      this.DOBval = "";
      this.file = "";
      this.uploadedimage = "";
      this.process = "N";
      this.inputdisable = false;
      this.modals.studentModal = false;
    },
    updatePassportVal(data) {
      this.ImgPathval = data;
    },
    edititem(item) {
      this.onloader = "flex";
      this.StudentIdVal = item.studentId;
      this.uploadedimage = item.passport || item.Passport || "";
      this.ImgPathval = item.passport || item.Passport || "";
      this.ContactIdval = item.contactId;
      this.GContactIdval = item.gContactId;
      this.GUserIdval = item.gUserId;
      this.GPhoneNoval = item.gPhoneNo;
      this.GTitleval = item.gTitle;
      this.GFirstnameval = item.gFirstName;
      this.GMiddlenameval = item.gMiddlename;
      this.GLastNameval = item.gLastName;
      this.GEmailval = item.gEmailAdd;
      this.GIdval = item.gId;
      this.FullAddressval = item.fullAddress;
      this.FirstNameval = item.firstName;
      this.Addressval = item.addressOne;
      this.AdmissionNoval = item.admNo;
      this.Admissiondateval = this.frontEndDateFormat(item.dateAdmited);
      this.ClassIdval = item.classId;
      this.getoption();
      this.OptionIdval = item.optionId;
      this.getarm();
      this.ArmIdval = item.sectionId;
      this.MiddleNameval = item.middleName;
      this.LastNameval = item.lastName;
      this.SexIdval = item.sexId;
      this.UserIdval = item.userId;
      if (item.dateOfBirth != null || item.dateOfBirth != "") {
        this.DOBval = this.frontEndDateFormat(item.dateOfBirth);
      }

      this.modals.studentModal = true
      this.process = "U";
      this.onloader = "none";
    },
    deletestudent(Id) {
      const student = (this.students || []).find(item => String(item.studentId) === String(Id));
      const locallyDeleted = !student || !student.isDeleted;
      const localPayload = {
        ...(student || {}),
        studentId: Id,
        Id,
        isDeleted: locallyDeleted,
        Username: this.$store.state.auth.username,
        Accesskey: this.$store.state.auth.accesskey
      };
      this.onloader = "flex";
      studentRepository.remove(localPayload).then(() => {
        this.students = (this.students || []).map(item => String(item.studentId) === String(Id)
          ? displayStudent({ ...item, isDeleted: locallyDeleted, syncStatus: 'pending' }) : item);
        this.onloader = "none";
        this.ShowAlertSuccess('Saved locally; synchronization pending', '');
      }).catch(err => {
        this.onloader = "none";
        this.ShowAlertError(err.message, '');
      });
    },
    submitdata() {
      let Id = this.StudentIdVal;
      let Passport = this.ImgPathval;
      let ContactId = this.ContactIdval;
      let GContactId = this.GContactIdval;
      let GUserId = this.GUserIdval;
      let GPhoneNo = this.GPhoneNoval;
      let GTitle = this.GTitleval;
      let GFirstname = this.GFirstnameval;
      let GMiddlename = this.GMiddlenameval;
      let GLastName = this.GLastNameval;
      let GEmail = this.GEmailval;
      let GId = this.GIdval;
      let FirstName = this.FirstNameval;
      let FullAddress = this.FullAddressval;
      let AdmissionNo = this.AdmissionNoval;
      let Admissiondate = this.Admissiondateval;
      let ClassId = this.ClassIdval;
      let OptionId = this.OptionIdval;
      let ArmId = this.ArmIdval;
      let MiddleName = this.MiddleNameval;
      let LastName = this.LastNameval;
      let SexId = this.SexIdval;
      let DOB = this.DOBval;
      let UserId = this.UserIdval;
      let processop = this.process;
      let username = this.$store.state.auth.username;
      let accesskey = this.$store.state.auth.accesskey;
      this.onloader = "flex";
      const payload = {
          Id,
          UserId,
          Passport,
          ContactId,
          GContactId,
          GUserId,
          GPhoneNo,
          GTitle,
          GFirstname,
          GMiddlename,
          GLastName,
          GEmail,
          GId,
          FullAddress,
          FirstName,
          AdmissionNo,
          Admissiondate,
          ClassId,
          OptionId,
          ArmId,
          MiddleName,
          LastName,
          SexId,
          DOB,
          processop,
          username,
          accesskey,
      };
      studentRepository[processop === 'N' ? 'create' : 'update'](payload)
        .then(localStudent => {
          const student = displayStudent({ ...localStudent, syncStatus: 'pending' });
          const index = (this.students || []).findIndex(item => String(item.studentId) === String(Id));
          if (index >= 0) this.$set(this.students, index, student);
          else this.students = [student, ...(this.students || [])];
          this.CloseForm();
          this.onloader = "none";
          this.ShowAlertSuccess('Saved locally; synchronization pending', '');
        })
        .catch(err => {
          this.onloader = "none";
          this.ShowAlertError(err.message, '');
        });
    },
    async getstudents() {
      const ownerAtStart = getCurrentUserScope();
      if (!ownerAtStart) {
        this.students = [];
        return;
      }
      this.onloader = "flex";
      let localStudents = [];
      try {
        localStudents = await studentRepository.list();
        if (getCurrentUserScope() !== ownerAtStart) return;
        this.students = localStudents.map(displayStudent);
        if (typeof navigator !== 'undefined' && navigator.onLine === false) {
          return;
        }
        const resp = await this.$store.dispatch("PortalStudent/GetSchoolStudents");
        if (getCurrentUserScope() !== ownerAtStart) return;
        const remoteStudents = resp && Array.isArray(resp.data) ? resp.data : [];
        await Promise.all(remoteStudents.map(student => studentRepository.cache(student)));
        if (getCurrentUserScope() !== ownerAtStart) return;
        const latest = await studentRepository.list();
        this.students = latest.map(displayStudent);
      } catch (err) {
        if (getCurrentUserScope() === ownerAtStart && !localStudents.length) {
          this.students = [];
          this.ShowAlertError(err && err.response && err.response.data || err.message || 'Unable to load student records.', '');
        }
      } finally {
        if (getCurrentUserScope() === ownerAtStart) this.onloader = "none";
      }
    },
    getclass() {
      this.$store
        .dispatch("getclass")
        .then((resp) => {
          this.schclass = resp;
        })
        .catch((err) => {
          this.ShowAlertError(err.response.data, '');
        });
    },
    getoption() {
      let ClassId = this.ClassIdval;
      this.OptionIdval = 0;
      this.armitems = null;
      if (ClassId > 0) {
        this.onloader = "flex";
        this.$store
          .dispatch("getoptionbyclass", ClassId)
          .then((resp) => {
            this.optionitems = resp;
            this.onloader = "none";
          })
          .catch((err) => {
            this.onloader = "none";
            this.ShowAlertError(err.response.data, '');
          });
      }
    },
    getarm() {
      this.armitems = null;
      this.ArmIdval = 0;
      let ClassId = this.ClassIdval;
      let OptionId = this.OptionIdval;
      let SchArm = "Search";
      let Id = 1;
      let processop = this.process;
      let username = this.$store.state.auth.username;
      let accesskey = this.$store.state.auth.accesskey;
      this.onloader = "flex";
      let payload = {
        Id,
        ClassId,
        OptionId,
        SchArm,
        processop,
        username,
        accesskey,
      };
      this.$store
        .dispatch("getarmbyoption", payload)
        .then((resp) => {
          this.armitems = resp;
          this.onloader = "none";
        })
        .catch((err) => {
          this.onloader = "none";
          this.ShowAlertError(err.response.data, '');
        });
    },
    getadmno() {
      this.onloader = "flex";
      this.$store
        .dispatch("getadmno")
        .then((resp) => {
          this.AdmissionNoval = resp;
          this.onloader = "none";
        })
        .catch((err) => {
          this.onloader = "none";
          this.ShowAlertError(err.response.data, '');
        });
    },
    GetStudentById() {
      this.onloader = "flex";
      this.$store
        .dispatch("PortalStudent/GetStudentById", this.StudentIdVal)
        .then((resp) => {
          this.studentitems = resp.data;
          console.log(resp.data);
          this.onloader = "none";
        })
        .catch((err) => {
          this.onloader = "none";
          this.ShowAlertError(err.response.data, '');
        });
    },
    addNote(StudentId) {
      this.StudentIdVal = StudentId;
      this.GetStudentById();
      this.modals.studentNoteModal = true;
    },
    addAchievement(StudentId) {
      this.StudentIdVal = StudentId;
      this.GetStudentById();
      this.modals.studentArchievementModal = true;
    },
    frontEndDateFormat(date) {
      return moment(date).format("YYYY-MM-DD");
    },
    backEndDateFormat(date) {
      return moment(date, "DD/MM/YYYY").format("YYYY-MM-DD");
    },
    handleBulkStudentCreated(localStudent) {
      const student = displayStudent({ ...localStudent, syncStatus: 'pending' });
      const index = (this.students || []).findIndex(
        item => String(item.studentId) === String(student.studentId) ||
                (student.admNo && String(item.admNo).trim().toLowerCase() === String(student.admNo).trim().toLowerCase())
      );
      if (index >= 0) {
        this.$set(this.students, index, student);
      } else {
        this.students = [student, ...(this.students || [])];
      }
    },

  },
  mounted() {
    this.getstudents();
    this.getclass();
    this.unsubscribeSynced = subscribeSynced(operation => {
      if (operation.ownerId === getCurrentUserScope() &&
          String(operation.entityKey || '').startsWith('student:')) this.getstudents();
    });
  },
  beforeDestroy() {
    if (this.unsubscribeSynced) this.unsubscribeSynced();
  },
};
</script>

<style>
.inputfile+label {
  font-size: 1.25em;
  font-weight: 700;
  color: white;
  background-color: black;
  display: inline-block;
}

.inputfile:focus+label,
.inputfile+label:hover {
  background-color: red;
}

.modal-dialog.modal-xl {
  max-width: 95vw !important;
}

.bulk-upload-modal-content {
  max-height: 94vh;
  overflow-y: auto;
}
</style>
